import { commonMixins } from '@/mixins/common/commonMixin'
import MessageMixin from '@/mixins/message'
import { expandURI, filterQuery } from '@/utils/ajax'
// import store from '@/store'
export const claimHistoryMixin = {
  data() {
    return {
      totalHistoryItems: 0,
      historyColumns: [
        { text: 'Entry Date', align: 'left', value: 'entDate' },
        { text: 'Status', align: 'left', value: 'clmStatDesc' },
        { text: 'Claimant', align: 'left', value: 'clmtNo' },
        { text: 'Item', align: 'left', value: 'clmItem' },
        { text: 'TranType', align: 'left', value: 'tranType1' },
        { text: 'Doc No ', align: 'left', value: 'docNo' },
        { text: 'Res/Payt Cat.', align: 'left', value: 'clmResCat' },
        { text: 'Local Amt', align: 'left', value: 'amtLoc' },
        { text: 'User ID', align: 'left', value: 'usrRefId' }
      ],
      historyItems: [],
      pagination: {
        sortDesc: [false],
        page: 1,
        itemsPerPage: 5
      }
    }
  },
  computed: {
    commonInfo() {
      return this.$store.state.claims.claimDetail.commonInfo
    },
    claimDetail() {
      return this.$store.state.claims.claimDetail
    }
  },
  methods: {
    async doFetchClaimHistory() {
      this.loading = true
      const apiUrl = this.claimDetail.menu.history
      if (apiUrl) {
        try {
          const { page, itemsPerPage } = this.paginationRIHeaders
          const expand = {
            page: page - 1,
            size: itemsPerPage,
            clmNo: this.commonInfo.clmNo
          }
          let filters = {
            blank: ''
          }
          const result = await this.$http.get(filterQuery(expandURI(apiUrl, expand), filters, this.paginationRIHeaders.sortBy, this.paginationRIHeaders.sortDesc))
          if (result && result.data) {
            const data = result.data.data.clmHistoryList
            this.totalHistoryItems = result.data.data.totalItems
            if (data) {
              this.$set(this, 'historyItems', data)
            } else {
              this.$set(this, 'historyItems', [])
            }
          } else {
            this.$toast.error('Unexpected server response')
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
        }
      } else {
        this.$toast.error('Missing API URL (fetch claim release txn)')
      }
      this.loading = false
    }
  },
  watch: {
    'pagination': function (value) {
      this.performSearch(false)
    }
  },
  mixins: [
    commonMixins,
    MessageMixin
  ]
}

export default claimHistoryMixin
